import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { SidenavService } from '../../../shared/services/sidenav.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit, AfterViewInit {

  constructor(private sidenavService: SidenavService) { }
  // @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild('sidenav') public sidenav!: MatSidenav;

  close() {
    this.sidenav.close();
  }
  ngOnInit(): void {

  }
  ngAfterViewInit() {
    this.sidenavService.setSidenav(this.sidenav);
  }
}
